import React from 'react'
import { Filter as FilterIcon } from 'react-feather'
import PropTypes from 'prop-types'
import { Box, Button, CircularProgress, Tooltip } from '@material-ui/core'

const FilterButton = ({
  disabled = false,
  fullWidth = false,
  id,
  isLoading = false,
  setDrawerOpen = () => {},
  ...rest
}) => {
  return (
    <Tooltip title="Filtros">
      <Button
        id={id}
        variant="outlined"
        onClick={() => setDrawerOpen(true)}
        startIcon={<FilterIcon width={18} />}
        fullWidth={fullWidth}
        disabled={isLoading || disabled}
        {...rest}
      >
        {isLoading ? <CircularProgress color="inherit" size={18} /> : 'Filtros'}
      </Button>
    </Tooltip>
  )
}

FilterButton.propTypes = {
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  isLoading: PropTypes.bool,
  setDrawerOpen: PropTypes.func,
}

export default FilterButton
